var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"id":"mailAccount","plain":true,"options":this.optionsDDL},on:{"change":_vm.onChange},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }